import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { CommonError, InlineError } from './types';
import type { FieldName } from 'store/userProfile/types';

export type CommonErrorState = {
  error: CommonError | null;
};
const initialState: CommonErrorState = {
  error: null,
};

export const commonErrorSlice = createSlice({
  name: 'commonError',
  initialState: initialState,
  reducers: {
    setCommonError(state, action: PayloadAction<CommonError>) {
      state.error = action.payload;
    },
    clearCommonError(state) {
      state.error = null;
    },
    clearSpecificInlineError(state, action: PayloadAction<FieldName>) {
      if (state.error?.type === 'inline' && state.error.fields.length > 0) {
        const inlineError = state.error as InlineError;
        const filteredErrors = inlineError.fields.filter(
          (field) => field.fieldName !== action.payload,
        );

        if (filteredErrors.length === 0) {
          state.error = null;
        } else {
          inlineError.fields = filteredErrors;
        }
      }
    },
  },
});

export const { setCommonError, clearCommonError, clearSpecificInlineError } =
  commonErrorSlice.actions;
export const commonErrorReducer = commonErrorSlice.reducer;
